import { useAnalytics } from 'app/context/Analytics';
import { PosthogEventName } from 'app/copied/constants/PosthogEventName';
import { RefObject, useEffect } from 'react';
import { useTailorHalfOpen } from 'app/hooks/useTailorHalfOpen';
import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';

export default function useOpenOnScroll(ref: RefObject<HTMLDivElement>) {
  const { setIsOpen } = useTailorIsOpen();
  const { halfOpen } = useTailorHalfOpen();
  const { captureEventWithActiveScreen } = useAnalytics();

  useEffect(() => {
    if (!halfOpen || !ref.current) return;

    const handleScroll: EventListener = ({ target }: Event) => {
      const isProgrammaticScroll = (target as HTMLDivElement).getAttribute('data-programmatic-scroll') === 'true';
      if (!isProgrammaticScroll) {
        setIsOpen(true);
        controller.abort();
        captureEventWithActiveScreen(PosthogEventName.HalfOpenExpanded);
      }
    };

    const controller = new AbortController();
    ref.current.addEventListener('scroll', handleScroll, {
      signal: controller.signal,
    });

    return () => controller.abort();
  }, [halfOpen, setIsOpen, captureEventWithActiveScreen, ref]);
}
